<template>
  <div>
    <div
      v-if="contestId === 1 || contestId === 0"
      class="rules-text-inner"
      :style="{
        background: bg || 'white',
      }"
    >
      <div
        :style="{
          position: 'relative',
        }"
      >
        <img :style="{ width: '19rem' }" src="../assets/images/rules/文本art.png" alt="" />

        <!-- <a
          :style="{
            position: 'absolute',
            left: '0rem',
            top: '37.5rem',
            width: '8.5rem',
            height: '0.8rem',
            border: '1px solid teal',
          }"
          href="https://azurlane8th.com/contest"
        >
        </a> -->

        <a
          :style="{
            position: 'absolute',
            left: '5rem',
            top: '88.2rem',
            width: '5.5rem',
            height: '0.8rem',
            // border: '1px solid teal',
          }"
          href="mailto:al.cs2@yo-star.com"
        ></a>
      </div>
    </div>

    <div v-if="contestId === 2" class="rules-text-inner">
      <div
        :style="{
          position: 'relative',
        }"
      >
        <!-- <a
          :style="{
            position: 'absolute',
            left: '0rem',
            top: '37.5rem',
            width: '8.5rem',
            height: '0.8rem',
            // border: '1px solid teal',
          }"
          href="https://azurlane8th.com/contest"
        >
        </a> -->

        <a
          :style="{
            position: 'absolute',
            left: '5rem',
            top: '73.5rem',
            width: '5.5rem',
            height: '0.8rem',
            // border: '1px solid teal',
          }"
          href="mailto:al.cs2@yo-star.com"
        ></a>

        <img :style="{ width: '19rem' }" src="../assets/images/rules/文本cos.png" alt="" />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ContestRulesContent',
  props: {
    contestId: {
      type: Number,
      required: true,
    },
    bg: {
      type: String,
    },
  },
}
</script>

<style lang="scss" scoped>
.rules-text-inner {
  background: white;
  padding: 0.5rem 0.8rem;
}
</style>
